import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { RecordInsightViews } from '~/features/insights/os/insight-views';

/** Add insight on a record: OS first (board dashboard-os-record-ask), or the one insight editor with `by=hand`. */
const search = z.object({ by: z.enum(['hand']).optional() });

function NewRoute(): ReactElement {
  const { recordId } = Route.useParams();
  const { by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <RecordInsightViews key={recordId} recordId={recordId} cardKey={null} by={by ?? null} onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })} />;
}

export const Route = createFileRoute('/_app/records/$recordId/insights/new')({ validateSearch: search, component: NewRoute });
